import {
  useDepartments,
  useDepartmentsForm,
} from "../../../hooks/offices/useDepartments";
import { API_DEPARTMENTS } from "../../../utils/apis";

export const officesRegisterRoutes = {
  departments: useDepartments,
};

export const officesFormRoutes = {
  departments: useDepartmentsForm,
};

export const officesApis = {
  departments: API_DEPARTMENTS,
};
